import { navigateAction } from 'fluxible-router';
import loadDocument from './loadDocument';
import SearchService from '../services/SearchService';
import SearchStore, { SearchResultState } from '../stores/SearchStore';

export default function performSearchAction(context, payload, done) {
  const { query, page = 1 } = payload;

  if (!query || query.length === 0) {
    if (done) done();
    return;
  }

  context.executeAction(navigateAction, { url: `/docs/search?q=${query}&page=${page}` });

  const success = async (response) => {
    await Promise.all(response.records.page.map(({ url }) =>
      loadDocument(context, { url })
    ));

    context.trackEvent('submit:docs:search-action', { trackData: query, track_data2: page });
    context.dispatch('SEARCH_RESULT_LOAD_SUCCESS', { query, page, response });
    if (done) done();
  };

  const failure = (err) => {
    context.dispatch('SEARCH_RESULT_LOAD_FAILURE', { query, page, err });
    if (done) done(err);
  };

  // If we've already loaded (or started to load) the result, don't do it again.
  const result = context.getStore(SearchStore).getResult({ query, page });
  if (
    result
    && (result.state === SearchResultState.LOADED
    || result.state === SearchResultState.LOADING)
  ) {
    return done();
  }

  // If the result hasn't been loaded (or a previous load resulted in
  // an error), try to load it using the SearchService.
  context.dispatch('SEARCH_RESULT_LOADING', { query, page });

  return SearchService.search({ query, page })
  .then(success)
  .catch(failure);
}
